import { AppSidebar } from '@components/shared/sidebar.component';
import { SIDEBAR_COOKIE_NAME, SidebarInset, SidebarProvider } from '@components/ui/sidebar';
import { MOBILE_BREAKPOINT } from '@hooks/mobile.hook';
import { cn } from '@lib/utils';
import Cookies from 'js-cookie';
import React from 'react';

type ReportLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const ReportLayout: React.FC<ReportLayoutProps> = (props) => {
  const { children, className } = props;

  const defaultOpen = Cookies.get(SIDEBAR_COOKIE_NAME) === 'true';
  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

  return (
    <SidebarProvider
      defaultOpen={defaultOpen && !isMobile}
      style={{ '--sidebar-width-icon': '52px' } as React.CSSProperties}
    >
      <AppSidebar />
      <SidebarInset>
        <div className={cn('max-w-[1440px] w-full p-4 flex flex-col sm:flex-row gap-4', className)}>
          <div className="flex flex-col w-full md:max-w-full">{children}</div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};
